module.exports = __webpack_public_path__ + "static/media/AirAvailabilityError.bb14c84e.webp";